import getBiRewardsGroup from 'services/api/beautyInsider/getBiRewardsGroup';
import BIApi from 'services/api/beautyInsider';
import UtilActions from 'utils/redux/Actions';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import store from 'store/Store';
import rougeExclusiveUtils from 'utils/rougeExclusive';
import helpers from 'utils/Helpers';

const isObject = helpers.isObject;

function fetchProfileRewards() {
    return dispatch => {
        getBiRewardsGroup.getBiRewardsGroupForCheckout().then(data => {
            const { basket } = store.getState();
            const updatedSkus = {
                ...data,
                biRewardGroups: {}
            };

            isObject(data?.biRewardGroups) &&
                Object.keys(data.biRewardGroups).length > 0 &&
                Object.keys(data.biRewardGroups).forEach(key => {
                    updatedSkus.biRewardGroups[key] = rougeExclusiveUtils.updateRougeExclusiveSkus(data.biRewardGroups[key], basket);
                });

            return dispatch(UtilActions.merge('rewards', 'rewards', updatedSkus));
        });
    };
}

function fetchRecentlyRedeemedRewards(userId, options) {
    return dispatch => {
        BIApi.getPurchaseHistory(userId, options).then(data => {
            const purchasedGroups = Array.isArray(data.purchasedGroups) ? data.purchasedGroups : [];
            Storage.local.setItem(LOCAL_STORAGE.REWARDS_PURCHASED_GROUPS, purchasedGroups);
            dispatch(UtilActions.merge('rewards', 'rewardsPurchasedGroups', purchasedGroups));
        });
    };
}

export default {
    fetchProfileRewards,
    fetchRecentlyRedeemedRewards
};
